// extracted by mini-css-extract-plugin
export var footer = "_ng-0";
export var inherit = "_ng-1";
export var input = "_ng-2";
export var modalContent = "_ng-3";
export var quillEditor = "_ng-4";
export var subtitle = "_ng-5";